import {IntlShape} from "react-intl";

/**
 * Provides a localized string to display the size of a file.
 *
 * @function
 * @param sizeInBytes - the size to convert to a reasonable unit
 * @param intl - react-intl instance to use for i18n
 */
export const formatFileSize = (sizeInBytes: number, intl: IntlShape) => {
  return intl.formatNumber(
    sizeInBytes <= 0
      ? 0
      : sizeInBytes /
          10 ** Math.min(Math.floor(Math.log10(sizeInBytes) / 3) * 3, 9),
    {
      style: "unit",
      unit:
        ["byte", "kilobyte", "megabyte", "gigabyte"][
          Math.floor(Math.log10(sizeInBytes) / 3)
        ] || "gigabyte",
      maximumSignificantDigits: 3,
    },
  );
};
